import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import InsertContract from "./components/InsertContract";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { useSetState } from "Helpers/Hooks";
import FactorService from "Services/http/endpoints/factor/FactorService";
import { Grid, useTheme } from "@material-ui/core";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import DatePickerComponent from "Components/DatePickerComponent/DatePickerComponent";
import MuiButton from "Components/MuiButton/MuiButton";
import showNotify from "Helpers/Notify";
import StatusHandler from "Helpers/StatusHandler";
import ContractService from "Services/http/endpoints/contract/ContractService";
import moment from "jalali-moment";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import PreviewDialog from "../Construction/components/PreviewDialog";
import {
  changeContract,
  changeTableData,
  editDataSelected,
  setInfoFactorContract,
} from "../../../Stores/actions/ContractActions";
import { useTranslation } from "react-i18next";
import * as R from "ramda";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { getLocaleDate } from "Helpers/GetLocaleDate";

function Contract() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const dispatch = useDispatch();
  const {
    selectedProject,
    tableDataContract,
    contractData,
    infoFactorContract,
  } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    tableDataContract: state.contract.tableDataContract,
    contractData: state.contract.contractData,
    infoFactorContract: state.contract.infoFactorContract,
  }));

  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({
    date: false,
    contractNumber: false,
  });
  const [checkValid, setCheckValid] = useState(false);
  const [date, setDate] = useState();
  const [dataContract, setDataContract] = useState();
  const [total, setTotal] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataPrint, setDataPrint] = useState(null);

  const [controls, setControls] = useSetState({
    idFactor: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    amountPaid: {
      value: "",
    },
    contractNumber: {
      value: "",
      validation: {
        required: true,
      },
    },
    description: {
      value: "",
      validation: {
        validation: null,
      },
    },
  });
  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "idFactor") {
      const priceFound = controls.idFactor.selectItems.find(
        (item) => item.Id === value.Id
      );
      const price = priceFound.price;
      setControls({ amountPaid: { value: price } });
      dispatch(setInfoFactorContract(priceFound));
    }
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onChange = (value) => {
    setDate(value);
    setFormValid((prev) => ({ ...prev, date: true }));
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      setCheckValid(false);
      const { contractNumber, idFactor, description, amountPaid } = controls;
      try {
        const newDate = getLocaleDate(date, direction);
        const price = convertToEnglishNumber(
          amountPaid.value.replaceAll(",", "")
        );
        const payments = tableDataContract.map((item) => {
          return {
            TypePayment: item.TypePayment,
            Price: item.Price,
            Bank: item.Bank,
            Branch: item.Branch,
            ShoDocument: item.ShoDocument,
            Date: item.Date,
            Description: item.Description,
          };
        });
        if (+price === total) {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Date: newDate,
            ShoContract: contractNumber.value,
            FactorId: idFactor.value.Id,
            ProjectId: selectedProject.Id,
            Description: description.value,
            Payments: payments,
          };
          const response = await ContractService.PostAllContract(params);
          let err = StatusHandler(response);
          if (!err.isFail) {
            showNotify({
              text: t("successfully_registered_contract"),
              customClass: "success",
            });
          }
        } else {
          showNotify({
            text: t("contract_amount_problem"),
            customClass: "error",
          });
        }
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
      document.getElementById("contract-details").scrollIntoView();
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        ProjectId: selectedProject.Id,
      };
      const response = await ContractService.DeleteContract(params);
      if (response) {
        onShowAlert();
        if (tableDataContract.length > 0 || contractData.length > 0) {
          dispatch(changeContract([]));
          dispatch(changeTableData([]));
          dispatch(editDataSelected(null));
          setControls({ description: { value: "" } });
          setControls({ idFactor: { value: "" } });
          setControls({ amountPaid: { value: "" } });
          setControls({ contractNumber: { value: "" } });
          setDate(null);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onShowAlert = () => {
    setShowAlert(!showAlert);
  };

  const onClick = async () => {
    const { idFactor } = controls;
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        FactorId: idFactor.value.Id,
        ProjectId: selectedProject.Id,
      };
      const response = await ContractService.PostContractPrint(data);
      const contractPrint = response.data.Value;
      setOpen(true);
      setDataPrint(contractPrint);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        dispatch(setInfoFactorContract(null));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
        };
        const response = await FactorService.getListArchiveFactorProject(
          params
        );
        const updatedData = response.data.Value.map((data) => {
          return {
            ...data,
            label: `${t("number")}: ${data.Sho} , ${t("archive")}:${
              data.Tarikh
            }  `,
            value: data.Id,
            price: data.Price,
          };
        });
        setControls({ idFactor: { selectItems: updatedData } });

        const paramsContract = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          ProjectId: selectedProject.Id,
        };
        const responseContract = await ContractService.GetAllContract(
          paramsContract
        );
        const updatedDataContract = responseContract.data.Value;
        setDataContract(updatedDataContract);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, [selectedProject]);

  useEffect(() => {
    if (dataContract?.Payments) {
      const FactorIdFound = controls?.idFactor?.selectItems.find(
        (item) => item.Id === dataContract?.FactorId
      );
      setControls({ idFactor: { value: FactorIdFound } });
      dispatch(setInfoFactorContract(FactorIdFound));
      const price = FactorIdFound.price;
      setControls({ amountPaid: { value: price } });
      setControls({ description: { value: dataContract?.Description } });
      setControls({ contractNumber: { value: dataContract?.ShoContract } });
      const dt = moment(dataContract?.DateRegister, "jYYYY/jM/jD");
      setDate(dt);
    }
  }, [dataContract]);

  useEffect(() => {
    let sum = 0;
    tableDataContract.forEach((item) => {
      sum = item.Price + sum;
    });
    setTotal(sum);
  }, [tableDataContract]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="project-section-head" id="contract-details">
        <PageTitle title={t("contract")} />
      </div>
      <MuiPaper className="mb-3">
        <Grid container spacing={2} className="p-3">
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <MuiAutoComplete
              placeholder={t("select_invoice")}
              options={controls.idFactor.selectItems}
              label={<Translator id={"invoices"} />}
              value={controls.idFactor.value}
              id="idFactor"
              onChange={autoCompleteHandler}
            />
          </Grid>
          {infoFactorContract && (
            <>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <Input
                  value={controls.amountPaid.value}
                  disabled={true}
                  label={<Translator id={"amountPaid"} />}
                  onChange={autoCompleteHandler}
                  className="price"
                  endIcon={<Translator id="moneyUnit" />}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  name="contractNumber"
                  validation={controls.contractNumber.validation}
                  label={<Translator id={"contractNumber"} />}
                  type="text"
                  value={controls.contractNumber.value}
                  checkValid={checkValid && !formValid["contractNumber"]}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <DatePickerComponent
                  label={t("date")}
                  onChange={onChange}
                  value={date}
                  validation={checkValid && !formValid["date"]}
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  className="w-100"
                  name="description"
                  validation={controls.description.validation}
                  label={<Translator id={"contractDescription"} />}
                  type="text"
                  value={controls.description.value}
                  multiline={true}
                  rows={3}
                />
              </Grid>
            </>
          )}
        </Grid>
      </MuiPaper>
      {infoFactorContract && (
        <>
          <InsertContract paid={controls.amountPaid.value} />
          <div className="d-flex flex-column flex-sm-row g-1 justify-content-end">
            {read("contractRules")?.accessRegister && (
              <MuiButton
                color="primary"
                title={<Translator id={"button_save"} />}
                onClick={onFinish}
                disabled={tableDataContract.length === 0}
                fullwidthOnSm
              />
            )}
            {read("contractRules")?.accessDelete && (
              <MuiButton
                color="secondary"
                title={<Translator id={"hazf"} />}
                onClick={onShowAlert}
                disabled={tableDataContract.length === 0}
                fullwidthOnSm
              />
            )}
            {read("contractRules")?.accessShow && (
              <MuiButton
                color="secondary"
                title={<Translator id={"preview"} />}
                onClick={onClick}
                disabled={tableDataContract.length === 0}
                fullwidthOnSm
              />
            )}
          </div>
          <AlertDialog
            showAlert={showAlert}
            type="alertError"
            onClose={onShowAlert}
            onClickOk={onDelete}
            okTitle={<Translator id="ble_pak_shavad" />}
            cancelTitle={<Translator id="enseraf" />}
            questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
          />
          <PreviewDialog
            open={open}
            handleClose={handleClose}
            data={dataPrint}
          />
        </>
      )}
    </>
  );
}

export default Contract;
